import { Controller } from '@hotwired/stimulus';

/** Scrolls the signed-in users chart to the most recent activity. */
export default class extends Controller {
  static targets = ['scroll'];

  connect() {
    requestAnimationFrame(() => this.revealRecentActivity());
  }

  revealRecentActivity() {
    if (!this.hasScrollTarget) return;

    const scroll = this.scrollTarget;
    const bars = scroll.querySelectorAll(
      '.admin-sign-in-chart__bar:not(.admin-sign-in-chart__bar--empty)',
    );
    const lastBar = bars[bars.length - 1];

    if (lastBar) {
      lastBar.scrollIntoView({ inline: 'end', block: 'nearest', behavior: 'instant' });
      return;
    }

    scroll.scrollLeft = scroll.scrollWidth - scroll.clientWidth;
  }
}
